import { autoinject, bindingMode } from 'aurelia-framework';
import { ComponentBase, SortDirection, Sorting, StandardLoadOptions } from 'app/shared/lib/essette-site';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ClaimService } from 'app/cd/services/claim-service';
import { apiCall } from 'app/shared/lib/api/api';
import * as CD from 'app/cd/models/essette-api';
import { EssPagerCustomElement } from 'app/shared/elements/ess-pager';
import { SortChangeEvent } from 'app/shared/attributes/sortable-attribute';


@autoinject()
export class ClaimNotes extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.stringNull({ defaultBindingMode: bindingMode.toView, changeHandler: 'reload' })
    public claimId: string | null = null;

    @bindable({ defaultBindingMode: bindingMode.toView })
    protected pageSize: number | undefined = 10;

    private sorting: Sorting = new Sorting();

    protected notes: CD.ClaimNote[] = [];
    protected noteResultCount: number = 0;

    ////****************** Element References ***************************************////
    protected $pagerNotes!: EssPagerCustomElement;

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly claimService: ClaimService,
        ...rest: any[]) {

        super(...rest);

        this.sorting.entries = [
            {
                reference: 'entered.dateTime',
                direction: SortDirection.Descending
            }
        ];
    }

    protected bind(): void {
        this.reload();
    }


    ////****************** Events ***************************************************////
    public async reload(): Promise<void> {
        await this.loadClaimNotes();
    }

    protected applySort(event: SortChangeEvent): void {
        const { property, direction } = event.detail;
        const { sorting } = this;
        if(direction === null) {
            sorting.remove(property);
        } else {
            sorting.add({
                reference: property,
                direction: direction === 'asc' ? SortDirection.Ascending : SortDirection.Descending
            });
        }
        this.reload();
    }

    ////****************** Functions ************************************************////

    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadClaimNotes(): Promise<void> {
        if(!this.claimId) return;

        const includes: string[] = [
            'entered.byUser',
            'category',
            'category.subCategory'
        ];

        const options: StandardLoadOptions = {
            sorting: this.sorting,
            top: this.pageSize,
            page: this.$pagerNotes?.page || 0,
            includeInactive: false
        };

        try {
            this.state.beginLoad();

            const responseNotes = await this.claimService.loadNotesByClaim(this.claimId, options, includes);
            this.notes = responseNotes.results;
            this.noteResultCount = responseNotes.count || 0;
        } catch(error) {
            throw error;
        } finally {
            this.state.endLoad();
        }
    }
}
